/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import Header from './comments-header';
import Body from './comments-body';
import sectionStyles from '../section/section.scss';
import activitiesStyles from './comments.scss';

const Comments = () => (
  <div styleName="activitiesStyles.activities-comments">
    <div styleName="sectionStyles.section">
      <Header />
      <Body />
    </div>
  </div>
);

export default memo(Comments);
